import {
    DFM_STATES,
    ImDfmStateType,
} from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'
import { Link } from 'react-router-dom'

import {
    OrderActivityQuoteItemQmrFragment,
    QuoteActivityQuoteItemQmrFragment,
} from '~/gql/graphql'
import getColor from '~/lib/getColor'

const ATTACHMENT_CREATED_ID = 'attachment_created'
const ATTACHMENT_CREATED_MSG = 'uploaded file '

const ATTACHMENT_DELETED_ID = 'attachment_deleted'
const ATTACHMENT_DELETED_MSG = 'deleted file '

const ATTACHMENT_DOWNLOADED_ID = 'attachment_downloaded'
const ATTACHMENT_DOWNLOADED_MSG = 'downloaded attachment '

const ATTACHMENT_REMOVED_ID = 'attachment_removed'
const ATTACHMENT_REMOVED_MSG = 'removed drawing '
const ATTACHMENT_REMOVED_MSG_TWO = 'from part '

const ATTACHMENT_REVISION_CREATED_ID = 'attachment_revision_created'
const ATTACHMENT_REVISION_CREATED_MSG = 'created an attachment revision'

const DFM_CONSULTATION_REQUESTED = 'dfm_consultation_requested'
const DFM_CONSULTATION_REQUESTED_MSG = 'scheduled a call with a DFM Specialist'

const DFM_REPORT_REMOVED_ID = 'dfm_report_removed'
const DFM_REPORT_REMOVED_MSG = 'deleted DFM report for'

const DFM_REPORT_UPLOADED_ID = 'dfm_report_uploaded'
const DFM_REPORT_UPLOADED_MSG = 'uploaded DFM report for'

const DRAWING_ANNOTATED_ID = 'drawing_annotated'
const DRAWING_ANNOTATED_MSG = 'has annotated a drawing for '

const DRAWING_GENERATED_ID = 'drawing_generated'
const DRAWING_GENERATED_MSG = 'generated a drawing for '

const NEW_QMR_VERSION_ID = 'new_qmr_version'
const NEW_QMR_VERSION_MSG = 'uploaded a new model revision for'

const QMR_ATTACHMENT_CREATED_ID = 'qmr_attachment_created'
const QMR_ATTACHMENT_CREATED_MSG = 'added drawing '
const QMR_ATTACHMENT_CREATED_MSG_TWO = 'to part '

export const QMR_PRICED_ID = 'qmr_priced'
export const QMR_PRICED_MSG = 'added pricing to quote for '

const QUOTE_CREATED_ID = 'quote_created'
const QUOTE_CREATED_MSG = 'created the quote'

const QUOTE_DFM_REPORTS_RELEASED_ID = 'quote_dfm_reports_released'
const QUOTE_DFM_REPORT_RELEASED_MSG = 'released DFM reports'

const QUOTE_PURCHASED_ID = 'quote_purchased'
const QUOTE_PURCHASED_MSG = 'placed the order'

const IM_DFM_FEEDBACK_ACCEPTED_ID = 'im_dfm_feedback_accepted'
const IM_DFM_FEEDBACK_ACCEPTED_MSG = 'approved'

export const QUOTE_RELEASED_ID = 'quote_released'
export const QUOTE_RELEASED_MSG = 'released quote to the customer'

export const QUOTE_REQUESTED_ID = 'quote_requested'
export const QUOTE_REQUESTED_MSG = 'submitted RFQ'

export const QUOTE_SHARED = 'quote_shared'
export const QUOTE_SHARED_MSG = 'shared this quote with '

export const QUOTE_FORWARDED = 'quote_forwarded'
export const QUOTE_FORWARDED_MSG = 'forwarded the quote to '

export const QUOTE_SENT_TO_PUNCHOUT = 'sent_to_punchout'
export const QUOTE_SENT_TO_PUNCHOUT_MESSAGE =
    'clicked “Send to punchout” to purchase via external procurement system'

const QUOTE_CHANGE_REQUESTED = 'change_requested'
const QUOTE_CHANGE_REQUESTED_PRE_MSG = 'requested '
const QUOTE_CHANGE_REQUESTED_POST_MSG = 'with the description'

const QUOTE_LOCKED_ID = 'quote_locked'
const QUOTE_LOCKED_MSG = 'has locked the quote'
const QUOTE_LOCKED_BY_CPQ_MSG = 'The quote was locked by case management'

const QUOTE_UNLOCKED_ID = 'quote_unlocked'
const QUOTE_UNLOCKED_MSG = 'has unlocked the quote'
const QUOTE_UNLOCKED_DESIGN_CHANGE_MSG =
    'has unlocked the quote to make a design change (new revision)'

const DFM_STATE_TRANSITION = 'dfm_state_transition'
const DFM_STATE_TRANSITION_MSG = 'changed status of '

const IM_DFM_FEEDBACK_CREATED = 'im_dfm_feedback_created'
const IM_2D_DFM_FEEDBACK_CREATED_MSG = 'uploaded DFM report for'
const IM_3D_DFM_FEEDBACK_CREATED_MSG = 'created DFM slide for'
const IM_DFM_3D_SOURCE_TYPE = '3d'

const IM_DFM_FEEDBACK_DELETED = 'im_dfm_feedback_deleted'
const IM_DFM_FEEDBACK_DELETED_MSG = 'deleted'

const DFM_FEEDBACK_FICTIV_NOTIFIED = 'dfm_feedback_fictiv_notified'
const DFM_FEEDBACK_FICTIV_NOTIFIED_MSG = 'reviewed DFM and notified Fictiv'

const QUOTE_CREATED_IN_ODOO = 'quote_created_in_odoo'
const QUOTE_CREATED_IN_ODOO_MSG = 'created the quote in Odoo.'

const QUOTE_MARKED_AS_FPQ = 'quote_marked_as_fpq'
const QUOTE_MARKED_AS_FPQ_MSG = 'initiated Flexible Price Quoting.'
const CLT_OPTIMIZER_VIEW = 'clt_optimizer_view'
const CLT_OPTIMIZER_VIEW_MSG = 'opened Lead Time Optimizer'

const CLT_OPTIMIZER_ACTION = 'clt_optimizer_action'

const QUOTE_NEED_BY_DATE_SET = 'quote_need_by_date_set'
const QUOTE_NEED_BY_DATE_SET_MSG = 'edited the target delivery date'

const CLT_REQUEST_ASSISTANCE = 'clt_request_assistance'
const CLT_REQUEST_ASSISTANCE_MSG =
    'requested assistance for lead-time reduction'

const RFQ_NOTES_UPDATED_ID = 'rfq_notes_updated'
const RFQ_NOTES_UPDATED_MESSAGE = 'updated RFQ notes'

const CPQ_QUOTE_RELEASED_ID = 'cpq_quote_released'
const CPQ_QUOTE_RELEASED_MESSAGE = 'The priced quote was received from CPQ.'

export const getDisplayTextFromList = (list: (string | undefined)[]) => {
    return [list.slice(0, -1).join(', '), list.slice(-1)[0]].join(
        list.length < 2 ? '' : ' and ',
    )
}

interface ActivityMessageTypeProps {
    message: string
    email?: string
    note?: string
}

interface CltOptimizationMessageTypeProps {
    fileName?: string
    operation?: string
    description?: string
}

const ActivityMessage = (props: ActivityMessageTypeProps) => {
    const { message, email, note } = props

    return (
        <>
            {message}
            <span style={{ fontWeight: 500, color: getColor('blackAlpha45') }}>
                {email}
            </span>
            {note && ' and said:'}
        </>
    )
}

const getActivityMessage = (operation?: string, description?: string) => {
    let activityMessage

    if (operation === 'update') {
        if (description == 'threads') {
            activityMessage = `chose to ${operation} drawing to remove ${description} for `
        }
        if (description === 'quantity') {
            activityMessage = `updated ${description} for `
        }
        if (description === 'tight-tolerance') {
            activityMessage = `chose to ${operation} drawing to remove ${description} for `
        }
    }
    if (operation === 'remove') {
        if (description === 'threads') {
            activityMessage = `removed all configured ${description} for `
        } else {
            activityMessage = `removed ${description} from `
        }
        if (description === 'some_threads') {
            activityMessage = `chose to update thread configuration for `
        }
    }
    if (operation === 'undo') {
        if (description) {
            activityMessage = `chose to ${operation} the removal of ${description} for `
        }
    }

    return activityMessage
}

const CltOptimizationMessage = (props: CltOptimizationMessageTypeProps) => {
    const { fileName, operation, description } = props
    const ACT_LOG_MSG_START = getActivityMessage(operation, description)
    const ACT_LOG_MSG_END = ' through Lead Time Optimizer'

    return (
        <>
            {ACT_LOG_MSG_START}
            <Link to="#">{fileName}</Link>
            {ACT_LOG_MSG_END}
        </>
    )
}

export const getLogActivity = (
    summary: string,
    partName?: string,
    topicLabel?: string,
    dfmTopicLabel?: string,
    qmrPricedFileNames?: (string | undefined)[],
    dfmStatus?: ImDfmStateType,
    note?: string,
    recipientEmail?: string,
    fileName?: string,
    operation?: string,
    description?: string,
    sourceType?: string,
    changeType?: string[],
    changeDescription?: string,
    isUnlockedForDesignChange?: boolean,
    isActionPerformedByCpq?: boolean,
) => {
    // example output:
    //  * abc.step
    //  * abc.step and abc123.step
    //  * abc.step, abc123.step and abc1234.step

    type changeMappingType = { [key: string]: string | number }

    const changeTypeTextMapping: changeMappingType = {
        designChange: ' design change (new revision)',
        quantityChange: ' quantity change',
        configurationChange: ' configuration change',
        otherChange: ' other change',
    }
    let qmrPricedFileNamesDisplay = ''
    const changeTypeStr = changeType
        ?.map(type => {
            return changeTypeTextMapping[type]
        })
        .join()

    if (qmrPricedFileNames?.length) {
        qmrPricedFileNamesDisplay = getDisplayTextFromList(qmrPricedFileNames)
    }

    switch (summary) {
        case ATTACHMENT_CREATED_ID:
            return `${ATTACHMENT_CREATED_MSG} (${fileName || 'unknown'})`
        case ATTACHMENT_DELETED_ID:
            return `${ATTACHMENT_DELETED_MSG} (${fileName || 'unknown'})`
        case ATTACHMENT_DOWNLOADED_ID:
            return `${ATTACHMENT_DOWNLOADED_MSG} (${fileName || 'unknown'})`
        case ATTACHMENT_REMOVED_ID:
            return `${ATTACHMENT_REMOVED_MSG} (${
                fileName || 'unknown'
            }) ${ATTACHMENT_REMOVED_MSG_TWO} (${partName || 'unknown'})`
        case ATTACHMENT_REVISION_CREATED_ID:
            return ATTACHMENT_REVISION_CREATED_MSG
        case DFM_CONSULTATION_REQUESTED:
            return DFM_CONSULTATION_REQUESTED_MSG
        case DFM_REPORT_REMOVED_ID:
            return `${DFM_REPORT_REMOVED_MSG} (${partName || 'unknown'})`
        case DFM_REPORT_UPLOADED_ID:
            return `${DFM_REPORT_UPLOADED_MSG} (${partName || 'unknown'})`
        case DRAWING_ANNOTATED_ID:
            return `${DRAWING_ANNOTATED_MSG} (${partName || 'unknown'})`
        case DRAWING_GENERATED_ID:
            return `${DRAWING_GENERATED_MSG}(${partName || 'unknown'})`
        case NEW_QMR_VERSION_ID:
            return `${NEW_QMR_VERSION_MSG} ${partName || 'unknown'}`
        case QMR_ATTACHMENT_CREATED_ID:
            return `${QMR_ATTACHMENT_CREATED_MSG} (${
                fileName || 'unknown'
            }) ${QMR_ATTACHMENT_CREATED_MSG_TWO} (${partName || 'unknown'})`
        case QMR_PRICED_ID:
            return `${QMR_PRICED_MSG}${qmrPricedFileNamesDisplay}`
        case QUOTE_CREATED_ID:
            return QUOTE_CREATED_MSG
        case QUOTE_DFM_REPORTS_RELEASED_ID:
            return QUOTE_DFM_REPORT_RELEASED_MSG
        case QUOTE_PURCHASED_ID:
            return QUOTE_PURCHASED_MSG
        case QUOTE_RELEASED_ID:
            return QUOTE_RELEASED_MSG
        case QUOTE_REQUESTED_ID:
            return QUOTE_REQUESTED_MSG
        case QUOTE_CHANGE_REQUESTED:
            return `${QUOTE_CHANGE_REQUESTED_PRE_MSG} ${changeTypeStr} ${QUOTE_CHANGE_REQUESTED_POST_MSG}: ${changeDescription}`
        case QUOTE_LOCKED_ID:
            return isActionPerformedByCpq
                ? QUOTE_LOCKED_BY_CPQ_MSG
                : QUOTE_LOCKED_MSG
        case QUOTE_UNLOCKED_ID:
            return isUnlockedForDesignChange
                ? QUOTE_UNLOCKED_DESIGN_CHANGE_MSG
                : QUOTE_UNLOCKED_MSG
        case QUOTE_SHARED:
            return (
                <ActivityMessage
                    message={QUOTE_SHARED_MSG}
                    note={note}
                    email={recipientEmail}
                />
            )
        case QUOTE_FORWARDED:
            return (
                <ActivityMessage
                    message={QUOTE_FORWARDED_MSG}
                    note={note}
                    email={recipientEmail}
                />
            )

        case DFM_STATE_TRANSITION:
            return `${DFM_STATE_TRANSITION_MSG} ${topicLabel || 'unknown'} to ${
                dfmStatus ? DFM_STATES[dfmStatus] : 'unknown'
            } for (${partName || 'unknown'})`
        case IM_DFM_FEEDBACK_CREATED:
            if (sourceType === IM_DFM_3D_SOURCE_TYPE) {
                return `${IM_3D_DFM_FEEDBACK_CREATED_MSG} (${
                    partName || 'unknown'
                })`
            }
            return `${IM_2D_DFM_FEEDBACK_CREATED_MSG} (${
                partName || 'unknown'
            })`
        case IM_DFM_FEEDBACK_DELETED:
            return `${IM_DFM_FEEDBACK_DELETED_MSG} ${
                topicLabel || 'unknown'
            } from (${partName || 'unknown'})`
        case DFM_FEEDBACK_FICTIV_NOTIFIED:
            return `${DFM_FEEDBACK_FICTIV_NOTIFIED_MSG}`
        case QUOTE_CREATED_IN_ODOO:
            return `${QUOTE_CREATED_IN_ODOO_MSG}`
        case QUOTE_MARKED_AS_FPQ:
            return `${QUOTE_MARKED_AS_FPQ_MSG}`
        case IM_DFM_FEEDBACK_ACCEPTED_ID:
            return `${IM_DFM_FEEDBACK_ACCEPTED_MSG} ${dfmTopicLabel} for ${
                partName || 'unknown'
            }`
        case CLT_OPTIMIZER_VIEW:
            return `${CLT_OPTIMIZER_VIEW_MSG}`
        case CLT_OPTIMIZER_ACTION:
            return (
                <CltOptimizationMessage
                    fileName={fileName}
                    operation={operation}
                    description={description}
                />
            )

        case QUOTE_NEED_BY_DATE_SET:
            return `${QUOTE_NEED_BY_DATE_SET_MSG}`
        case CLT_REQUEST_ASSISTANCE:
            return `${CLT_REQUEST_ASSISTANCE_MSG}`
        case RFQ_NOTES_UPDATED_ID:
            return `${RFQ_NOTES_UPDATED_MESSAGE}`
        case CPQ_QUOTE_RELEASED_ID:
            return `${CPQ_QUOTE_RELEASED_MESSAGE}`
        case QUOTE_SENT_TO_PUNCHOUT:
            return `${QUOTE_SENT_TO_PUNCHOUT_MESSAGE}`
        default:
            return null
    }
}

type QuoteItemType =
    | QuoteActivityQuoteItemQmrFragment
    | OrderActivityQuoteItemQmrFragment

export const getFileNamesForQmrPricedLog = (
    quoteItems: QuoteItemType[],
    summary: string,
    targetId: string,
): string[] => {
    return quoteItems
        .map((quoteItem: QuoteItemType) => {
            const { fileName, id } = quoteItem.quoteModelRevision

            if (summary === QMR_PRICED_ID && targetId === id) {
                return fileName
            }
        })
        .filter(Boolean) as string[]
}
